<template>
  <div id="ledger_container">
    <renderjson v-bind:data="rendered_ledger" style="height: 100%"/>
  </div>
</template>

<script>
// VueJsonPretty is slow (possibly due to recursive nature)
// TODO: look into improving performance of this & introduce
//       slot system where vue templates can be rendered inplace
//       of jsonpath specified data (remove 'transform' below)
//import VueJsonPretty from 'vue-json-pretty'

import renderjson from '../vendor/renderjson/renderjson.vue'
import util       from '../util'

export default {
  name: 'RenderedLedger',

  props : {
    ledger : Object
  },

  components : {
    renderjson
  },

  computed : {
    have_ledger : function(){
      return !!this.ledger.ledger_index;
    },

    rendered_ledger : function(){
      var ledger = JSON.parse(JSON.stringify(this.ledger));
      return this.have_ledger ?
             util.transform_ledger_json(ledger) : null;
    }
  }
}
</script>

<style scoped>
#ledger_container{
  background-color: white;
  padding: 10px;
  height: 100%;
}
</style>
